import React, { createContext, useState, useEffect, useContext } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase_utils/firebase';
import { useNavigate, useLocation } from 'react-router-dom';

export const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [previousAuthState, setPreviousAuthState] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Strictly protected paths that require redirect to home
  const protectedPaths = [
    // Add your tool routes here
    '/app/tools/story',
    '/app/tools/quick-story',
    '/app/tools/photo-books'
  ];

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      const isLogout = previousAuthState && !currentUser;
      
      setUser(currentUser);
      setPreviousAuthState(currentUser);
      setLoading(false);

      if (isLogout) {
        // Check if current path is protected
        const isProtectedPath = protectedPaths.some(path => 
          location.pathname.startsWith(path)
        );
        
        if (isProtectedPath) {
          // Redirect protected paths to home
          setTimeout(() => {
            navigate('/', { replace: true });
          }, 100);
        }
      }
    });

    return () => unsubscribe();
  }, [navigate, location.pathname, previousAuthState]);

  const value = {
    user,
    loading,
    error,
    setError
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};